export default __webpack_public_path__ + "static/media/MoodFall.3a404237.png";